import React from 'react';
import { Modal } from 'shared/Modal';
import { Button } from 'shared/Button/NewButton';
import { css } from 'emotion';

const DeleteMediaConfirmationModal = ({
  hideConfirmationModal,
  onDelete,
  deleteStatus,
}: {
  hideConfirmationModal: () => void;
  onDelete: () => void;
  deleteStatus: string;
}) => (
  <Modal
    label="deleteMediaConfirmationModal"
    isShowing={true}
    isShowingCloseButton={true}
    onClickClose={hideConfirmationModal}
    onClickOutside={hideConfirmationModal}
    renderContent={() => (
      <div
        className={css`
          text-align: center;
        `}
      >
        <h4 id="modalTitle">Delete this audio?</h4>
        <p
          className={css`
            margin-bottom: 16px;
          `}
        >
          This action will remove all media content associated with your
          episode.
        </p>
        <Button
          color="red"
          onClick={onDelete}
          isDisabled={deleteStatus === 'loading'}
        >
          <span>Delete</span>
        </Button>
        {/* TODO: Add error messaging */}
      </div>
    )}
  />
);

export { DeleteMediaConfirmationModal };
